<template>
  <div class="publicAdvertisingMP">
    <div class="publicAdvertisingMP_button">
      <el-button type="primary" @click="popup = true">创建旧版mp计划</el-button>
      <el-button type="primary" @click="$router.replace('/newEdition')">创建新版mp计划</el-button>
    </div>
    <div class="publicAdvertisingMP_main">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          fixed
          prop="campaign_name"
          label="名称"
          width="150"
        />
        <el-table-column
          prop="id"
          label="id"
          width="120"
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
        >
          <template slot-scope="scope">
            <span>{{ interceptionTime(scope.row.created_at) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="120"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="$router.replace({
                path:'/oldReleasePlan/index',
                query:{
                  account_id: scope.row.account_id,
                  index: 3,
                  ad_name: scope.row.ad_name,
                  id: scope.row.id
                }
              })"
            >
              编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="publicAdvertisingMP_pageing">
        <el-pagination
          layout="prev, pager, next"
          :total="tatol"
          @current-change="(page = $event),(getList())"
        />
      </div>
    </div>

    <el-dialog
      title="公共mp"
      :visible.sync="popup"
    >
      <Popup />
    </el-dialog>
  </div>
</template>

<script>
import { getAccountList } from '@/api/publicAdvertisingMP.js'
import Popup from './components/popup.vue'
export default {
  components: {
    Popup
  },
  data() {
    return {
      tableData: [],
      page: 1,
      tatol: null,
      ad_name: '',
      loading: false,
      popup: false
    }
  },

  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      const data = await getAccountList({
        account_id: this.$route.query.account_id,
        page: this.page
      })
      this.loading = false
      this.tableData = data.data.list
      this.tatol = data.data.count
    },
    interceptionTime(time) {
      if (!time) {
        return
      }
      const index = time.indexOf('T')
      return time.slice(0, index)
    }
  }

}
</script>

<style lang="less" scoped>
.publicAdvertisingMP{
  width: 95%;
  margin: 0 auto;
  margin-top: 25px;
  border: 1px solid #dfe6ec;
  border-radius: 5px;
  .publicAdvertisingMP_button{
      padding: 10px;
  }
  .publicAdvertisingMP_main{

  }
  .publicAdvertisingMP_pageing{
      padding: 10px;
      display: flex;
      justify-content: flex-end;
  }
}

</style>
